import React, { Component } from 'react';
import { Link } from 'react-router';

import dispatcher from "../dispatcher";
import SessionStore from "../stores/SessionStore";

import '../index.css';

var logoMap = [
  {
    org: "sindcon",
    logo: "vendor/swagger/images/logo_sindcon.png",
    website: "http://www.sindcon.com.sg/"
  },
  {
    org: "das",
    logo: "vendor/swagger/images/logo_das.png",
    website: "https://ptdas.co.id/"
  },
  {
    org: "pgn",
    logo: "vendor/swagger/images/logo_pgn.png",
    website: "https://www.pgn.co.id/"
  },
  {
    org: "bu",
    logo: "vendor/swagger/images/logo_bu.png",
    website: "http://www.pdamkotabogor.go.id/"
  },
  {
    org: "nebula",
    logo: "vendor/swagger/images/logo_nebula.png",
    website: ""
  },
  {
    org: "mhs",
    logo: "vendor/swagger/images/logo_mhs.png",
    website: ""
  },
  {
    org: "unknow",
    logo: "vendor/swagger/images/logo_none.png",
    website: "https://lora-alliance.org/"
  }    
];

var userOrgMap = [
  {
    username: "DAS",
    org: "das"
  },
  {
    username: "pgn",
    org: "pgn"
  },
  {
    username: "BogorUtility",
    org: "bu"
  },
  {
    username: "nebula",
    org: "nebula"
  },
  {
    username: "admin",
    org: "sindcon"
  },
  {
    username: "cwh",
    org: "sindcon"
  },
  {
    username: "cdy",
    org: "sindcon"
  },
  {
    username: "mhs",
    org: "mhs"
  },
];

class Navbar extends Component {
  static contextTypes = {
    router: React.PropTypes.object.isRequired
  };


  constructor() {
    super();
    this.state = {
      user: SessionStore.getUser(),
      isAdmin: SessionStore.isAdmin(),
      customServer: SessionStore.customServer,
      userDropdownOpen: false,
    }

    this.userToggleDropdown = this.userToggleDropdown.bind(this);
    this.handleActions = this.handleActions.bind(this);
  }

  userToggleDropdown() {
	    this.setState({
	      userDropdownOpen: !this.state.userDropdownOpen,
	    });
	  }

  handleActions(action) {
    switch(action.type) {
      case "BODY_CLICK": {
        this.setState({
            userDropdownOpen: false,
        });
        break;
      }
      default:
        break;
    }
  }

  componentWillMount() {
    SessionStore.on("change", () => {
      this.setState({
        user: SessionStore.getUser(),
        isAdmin: SessionStore.isAdmin(),
        customServer: SessionStore.customServer,
      });
    });
    dispatcher.register(this.handleActions);
  }

  render() {
    // console.log("---> user=", this.state.user);
    var org = "unknow";
    
    if ((typeof(this.state.user.username) === "undefined") || (this.state.customServer == "undefined")){
      org = "unknow";
    } else {
      var username = this.state.user.username.toLowerCase();
      for (var i = 0; i < userOrgMap.length; i++) {
        if (userOrgMap[i].username.toLowerCase() == username) {
          org = userOrgMap[i].org;
          break;
        }
      }
    }

    if (this.state.customServer === "undefined") {
      this.state.customServer = SessionStore.customServer;
    }
    org.toLowerCase()
    let logo = logoMap[0];

    for (var i = 0; i < logoMap.length; i++) {
      // console.log("logoMap[" + i + "]: ", logoMap[i].org, ", logoMap[i].org.toLowerCase() === org: ", (logoMap[i].org.toLowerCase() === org))
      if (logoMap[i].org.toLowerCase() === org) {
        logo = logoMap[i];
        break;
      }
    }

    for (var i = 0; i < logoMap.length; i++) {
      if (logoMap[i].org.toLowerCase() === this.state.customServer) {
        logo = logoMap[i];
        if (org === "unknow" && (typeof(this.state.user.username) !== "undefined")){
	        org = logoMap[i].org.toLowerCase();
        }
        break;
      }
    }
    
   if (org === "unknow" && (typeof(this.state.user.username) !== "undefined")){
      org = "sindcon";
	    logo = logoMap[0];
   }

    // console.log("org=", org, ", logo=", logo);

    return (
      <nav id={"nav_bar_"+org} className="navbar navbar-inverse navbar-fixed-top">
        <div className="container-fluid">

          <div className={org === "unknow" ? "hidden" : "navbar-header"}>
            <a className="media-object" target="_blank" href={logo.website}><img src={logo.logo} height="64" width="auto" alt="LoRa Server"/></a>
          </div>

          <div id="navbar" className="collapse navbar-collapse">  
          
            <ul className="nav navbar-nav">
              <li className={(typeof(this.state.user.username) === "undefined") && (this.state.customServer === "") ? "" : "hidden"}><div id="nav_lora_server">LoRa Server</div></li>
              <li className={(typeof(this.state.user.username) === "undefined") && (this.state.customServer === "mhs") ? "" : "hidden"}><div id="nav_mhs_lora_server">{SessionStore.title}</div></li>
              <li className={typeof(this.state.user.username) === "undefined" ? "hidden" : ""}><Link to="organizations">Organizations</Link></li>
              <li className={this.state.isAdmin === true ? "" : "hidden"}><Link to="users">Users</Link></li>
              <li className={typeof(this.state.user.username) === "undefined" ? "hidden" : ""}><Link to="/bands">Bands</Link></li>
              <li className={this.state.isAdmin === true ? "" : "hidden"}><Link to="/channels">Channel lists</Link></li>
            </ul>

            <ul className="nav navbar-nav navbar-right">
              
              <li className={(typeof(this.state.user.username) === "undefined") && (this.state.customServer === "mhs")  ? "" : "hidden"}>
                <div className={ "navbar-header"}>
                  <a className="media-object" target="_blank" href={logo.website}><img src={logo.logo} height="64" width="auto" alt="LoRa Server"/></a>
                </div>
              </li>

              <li className={"dropdown " + (typeof(this.state.user.username) === "undefined" ? "hidden" : "") + (this.state.userDropdownOpen ? "open" : "")}>
                <Link onClick={this.userToggleDropdown} className="dropdown-toggle">{this.state.user.username} <span className="caret" /></Link>
                <ul className="dropdown-menu" onClick={this.userToggleDropdown}>
                  <li><Link to={`users/${this.state.user.id}/password`}>Change password</Link></li>
                  <li><Link to="login">Logout</Link></li>
                </ul>
              </li>

            </ul> 

          </div>

        </div>
      </nav>
    );
  }
}

export default Navbar;



// WEBPACK FOOTER //
// ./src/components/Navbar.js